import { Fancybox } from "@fancyapps/ui";
import Faqs from "../../../frontend/blocks/faqs/faqs.js";
import HeaderScroll from "./components/HeaderScroll.js";
import Carousel from "./components/Carousel.js";
import MobileMenu from "./components/MobileMenu.js";
import Toggle from "./components/Toggle.js";
import FooterToggle from "./components/FooterToggle.js";
import Tabs from "./components/Tabs.js";
import GformUpload from "./components/GformUpload.js";
import SmoothScroll from "./components/SmoothScroll.js";
import ArchiveHero from "../../../frontend/blocks/archive-hero/archive-hero.js";
import NumberCounter from "./components/NumberCounter.js";
import ImageGalleryVideoSlider from "../../../frontend/blocks/image-gallery-video/image-gallery-video";
import "../../../node_modules/vanilla-cookieconsent/dist/cookieconsent.js";
import MediaColumns from "../../../frontend/blocks/media-columns/media-columns";
import MediaTextarea from "../../../frontend/blocks/media-textarea/media-textarea";
import GoogleMaps from "../../../frontend/blocks/google-map/google-map.js";
import FlickityMatchHeight from './components/FlickityMatchHeight.js';
import FormBlock from "../../../frontend/blocks/form-block/form-block.js";
import PopupSearch from "./components/PopupSearch.js";
import { NavigationOverlay } from "./components/NavigationOverlay.js";
import { SearchClear }  from "./components/SearchClear.js";
import Animate from "./components/Animate.js";
import { HomeHero } from './components/HomeHero.js';


{
    Animate();
}

{
    // Load the match height fix for Flickiy slides
    FlickityMatchHeight();
}

{
    const iconColumnsSlides = document.querySelector("[data-icon-columns]");

    if (typeof iconColumnsSlides != "undefined" && iconColumnsSlides != null) {
        IconColumnsSlider(iconColumnsSlides);
    }
}

{
    const numberCounter = document.querySelector(".js-count-up");
    if (typeof numberCounter != "undefined" && numberCounter != null) {
        NumberCounter();
    }
}

{
    const mediaColumns = document.querySelector(".media-columns__row");

    if (typeof mediaColumns != "undefined" && mediaColumns != null) {
        MediaColumns();
    }
}

{
    const mediaTextarea = document.querySelector(".media-textarea__slider");

    if (typeof mediaTextarea != "undefined" && mediaTextarea != null) {
        MediaTextarea();
    }
}

{
    const archiveHero = document.querySelector(".archive-hero__nav-wrap");

    if (typeof archiveHero != "undefined" && archiveHero) {
        ArchiveHero();
    }
}

{
    const slider = document.querySelector(".carousel");

    if (typeof slider != "undefined" && slider) {
        Carousel();
    }
}

{
    const formBlock = document.querySelector(".form-block");

    if (typeof formBlock != "undefined" && formBlock) {
        FormBlock();
    }
}


{
    const header = document.querySelector(".header");

    if (typeof header != "undefined" && header) {
        HeaderScroll();
    }
}

{
    const faqs = document.querySelector("[data-question]");

    if (typeof faqs != "undefined" && faqs) {
        Faqs();
    }
}

{
    const mobile_menu = document.querySelector(".mobile-menu");

    if (typeof mobile_menu != "undefined" && mobile_menu) {
        MobileMenu();
    }
}

{
    const toggle_element = document.querySelector("[data-toggle]");

    if (typeof toggle_element != "undefined" && toggle_element) {
        Toggle();
    }
}

{
    const footer_toggle = document.querySelector("[data-footer-toggle]");

    if (typeof footer_toggle != "undefined" && footer_toggle) {
        FooterToggle();
    }
}

{
    const tabs = document.querySelector("[data-tabs]");

    if (typeof tabs != "undefined" && tabs != null) {
        Tabs();
    }
}

{
    if (typeof gform != "undefined" && gform != null) {
        GformUpload();
    }
}

{
    const anchorLink = document.querySelector("[data-smooth-scroll]");

    if (typeof anchorLink != "undefined" && anchorLink != null) {
        SmoothScroll(anchorLink);
    }
}

{
    const imageGalleryVideoSlider = document.querySelector(
        ".image-gallery-video__images--slider"
    );

    if (
        typeof imageGalleryVideoSlider != "undefined" &&
        imageGalleryVideoSlider != null
    ) {
        ImageGalleryVideoSlider(imageGalleryVideoSlider);
    }
}

{
    const popupSearch = document.querySelector('[data-popup-search]');

    if (typeof popupSearch  != "undefined" && popupSearch  != null) {
        PopupSearch(popupSearch);
    }
}

{
    const searchClear = document.querySelector('.search-form__field');
    if (typeof searchClear !== "undefined" && searchClear !== null) {
        SearchClear(searchClear);
    }
}

{
    const navigationOverlay = document.querySelector('.header__item--parent');

    if (typeof navigationOverlay !== "undefined" && navigationOverlay !== null) {
        NavigationOverlay();
    }
}

{
    const homeHero = document.getElementById('home-hero');
    if (typeof homeHero !== "undefined" && homeHero !== null) {
        HomeHero();
    }
}
